export default __webpack_public_path__ + "545b359c55227ad6a632ff3e539d0a7d.png";